<script setup lang="ts">

import {mergeProps} from "vue";

interface Props {
    disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
    disabled: false
})

const value = defineModel<boolean>()
const emit = defineEmits<{ submit: []}>()

const submit = () => {
    value.value = false;
    emit('submit');
}
</script>

<template>
    <v-dialog
        v-model="value"
        max-width="500"
        scrim="blue-grey-darken-4"
        opacity="0.5"
        transition="dialog-top-transition"
    >
        <template #activator="{ props: bind }">
            <v-tooltip
                location="end"
                content-class="bg-black border-sm text-tooltip"
                max-width="200"
            >
                <template #activator="{ props: sub }">
                    <v-icon-btn
                        v-bind="mergeProps(bind, sub)"
                        icon="mdi-trash-can-outline"
                        size="small"
                        color="transparent"
                        rounded="lg"
                        :disabled="props.disabled"
                    />
                </template>
                Delete
            </v-tooltip>
        </template>
        <template #default>
            <v-card
                class="pa-1"
                rounded="lg"
            >
                <v-card-title
                    class="font-weight-bold"
                >
                    <slot name="title">
                        Are you sure you want to delete this?
                    </slot>
                    <v-btn
                        :icon="true"
                        color="base"
                        variant="plain"
                        rounded="lg"
                        class="float-end"
                        size="32"
                        @click="value = false"
                    >
                        <v-icon size="20">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-actions class="pt-5">
                    <v-spacer />
                    <v-btn
                        color="white"
                        variant="flat"
                        border="sm"
                        type="button"
                        @click="value = false"
                    >
                        <span class="font-weight-regular">
                            Cancel
                        </span>
                    </v-btn>
                    <v-btn
                        color="error"
                        variant="flat"
                        border="sm"
                        @click="submit"
                    >
                        <span class="font-weight-regular">
                            Yes, delete it
                        </span>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>

<style scoped>

</style>
